import { useContext, useEffect, useState } from 'react';
import { CartContext } from '../CartContex';

const Cart = () => {
    const [products, setProducts] = useState([]);
    let total = 0;
    const { cart, setCart } = useContext(CartContext);
    const [priceFetched, toggglePriceFetched] = useState(false);

    useEffect(() => {
        const fetchProduct = () => {
            if (!cart.items || Object.keys(cart.items).length === 0) {
                // If cart is empty or undefined, return early
                return;
            }
            const itemIds = Object.keys(cart.items);
    
            if (priceFetched) {
                return;
            }
            fetch('/products.json')
                .then(res => {
                    if (!res.ok) {
                        throw new Error('Failed to fetch products');
                    }
                    return res.json();
                })
                .then(products => {
                    // Filter products to include only those with IDs present in the cart
                    const filteredProducts = products.filter(product => itemIds.includes(product.id.toString()));
                    setProducts(filteredProducts);
                    toggglePriceFetched(true);
                })
                .catch(error => {
                    console.error('Error fetching products:', error);
                    // Handle error, e.g., set an error state
                });
        };
    
        fetchProduct();
    }, [cart,priceFetched]);

   
    const increment = (productId) => {
        const oldQty = cart.items[productId];
        const _cart = { ...cart }
        _cart.items[productId] = oldQty + 1;
        _cart.totalItems += 1;
        setCart(_cart);
    }
    const decrement = (productId) => {
        const oldQty = cart.items[productId];
        if (oldQty === 1) {
            return;
        }
        const _cart = { ...cart }
        _cart.items[productId] = oldQty - 1;
        _cart.totalItems -= 1;
        setCart(_cart);

    }
    const getsum = (productId, productPrice) => {
        let qty = cart.items[productId];
        const price = qty * productPrice;
        total += price;

        return price;

    }
    const handleDelete = (productId) => {
        const _cart = { ...cart };
        const qty = cart.items[productId];
        delete _cart.items[productId];
        _cart.totalItems -= qty;
        setCart(_cart);
        setProducts(products.filter((product) => product.id !== productId));

    }
    const orderPlaced = () => {
        alert('your order placed sucessfully...!!');
        setProducts([]);
        setCart({});
    }

    return (
        products.length ?
            <div className='container mx-auto p-4'>
                <h1 className='my-4 font-bold text-2xl text-center lg:text-left'>Cart items</h1>
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                        <thead>
                            <tr>
                                <th className="px-3 py-2 text-left">Item</th>
                                <th className="px-3 py-2 text-left">Quantity</th>
                                <th className="px-3 py-2 text-left">Price</th>
                                <th className="px-3 py-2 text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map(product => (
                                <tr key={product.id}>
                                    <td className="border px-3 py-2">
                                        <div className='flex flex-col items-center'>
                                            <img className="h-12 w-auto mb-2" src={product.image} alt={product.name} />
                                            <span className='font-bold'>{product.name}</span>
                                        </div>
                                    </td>
                                    <td className="border px-3 py-2">
                                        <div className="flex items-center">
                                            <button onClick={() => { decrement(product.id) }} className='bg-yellow-500 px-2 py-1 rounded-full leading-none'>-</button>
                                            <b className='px-2'>{cart.items[product.id]}</b>
                                            <button onClick={() => { increment(product.id) }} className='bg-yellow-500 px-2 py-1 rounded-full leading-none'>+</button>
                                        </div>
                                    </td>
                                    <td className="border px-3 py-2">
                                        <span className='font-bold'>{getsum(product.id, product.price).toFixed(2)}</span>
                                    </td>
                                    <td className="border px-3 py-2">
                                        <button onClick={() => { handleDelete(product.id) }} className='bg-red-500 px-2 py-1 rounded-full leading-none text-white'>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <hr className='my-4' />
                <div className='text-right'>
                    <b>Grand Total :</b> {total.toFixed(2)} {/* Calculate total dynamically */}
                </div>
                <div className='text-right mt-4'>
                    <button onClick={orderPlaced} className='bg-yellow-500 px-4 py-2 rounded-full leading-none'>Order Now</button>
                </div>
            </div> :
            <img className='mx-auto w-1/2' src="https://s3.envato.com/files/257601494/Troley_3.jpg" alt="" srcset="" />
    )
}

export default Cart;
